import { ComponentType, memo } from 'react';

export function typedMemo<T>(component: ComponentType<T>) {
  return memo(component) as ComponentType<T>;
}
